<template>
  <el-dialog
    :title="isEdit ? '编辑商品' : '新增商品'"
    :visible.sync="visible"
    width="750px"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入商品名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品分类" prop="categoryId">
            <el-select v-model="form.categoryId" placeholder="请选择分类" style="width: 100%;">
              <el-option
                v-for="cat in categoryList"
                :key="cat.id"
                :label="cat.name"
                :value="Number(cat.id)"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="品牌" prop="brand">
            <el-input v-model="form.brand" placeholder="请输入品牌" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成色" prop="fineness">
            <el-select v-model="form.fineness" placeholder="请选择成色" style="width: 100%;" @change="handleFinenessChange">
              <el-option label="全新" value="wholeNew" />
              <el-option label="准新" value="quasiNew" />
              <el-option label="99新" value="99new" />
              <el-option label="95新" value="95new" />
              <el-option label="9成新" value="90new" />
              <el-option label="8成新" value="80new" />
              <el-option label="7成新" value="70new" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="库存" prop="stock">
            <el-input-number v-model="form.stock" :min="0" :max="99999" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="商品价值" prop="itemValue">
            <el-input v-model="form.itemValue" placeholder="请输入商品价值">
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="押金" prop="depositPrice">
            <el-input-number v-model="form.depositPrice" :min="0" :precision="2" :step="0.01" placeholder="请输入押金" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">下架</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="商品图片" prop="images">
        <el-upload
          action="/api/admin/upload"
          list-type="picture-card"
          :file-list="imageList"
          :on-preview="handlePicturePreview"
          :on-remove="handlePictureRemove"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="previewVisible" append-to-body>
          <img :src="previewUrl" style="width: 100%;" alt="" />
        </el-dialog>
      </el-form-item>

      <el-form-item label="商品描述" prop="description">
        <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入商品描述" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createGoods, updateGoods } from '@/api/goods'
import { getAllCategories } from '@/api/category'

export default {
  name: 'GoodsForm',
  data() {
    return {
      visible: false,
      isEdit: false,
      editingId: null,
      submitting: false,
      categoryList: [],
      previewVisible: false,
      previewUrl: '',
      imageList: [],
      form: {
        name: '',
        categoryId: null,
        description: '',
        brand: '',
        fineness: '',
        finenessGrade: '',
        itemValue: '',
        depositPrice: '',
        stock: 1,
        status: 1,
        images: ''
      },
      rules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择商品分类', trigger: 'change' }],
        description: [{ required: true, message: '请输入商品描述', trigger: 'blur' }],
        itemValue: [{ required: true, message: '请输入商品价值', trigger: 'blur' }],
        depositPrice: [{ required: true, message: '请输入押金', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      try {
        const res = await getAllCategories()
        this.categoryList = res.data || []
      } catch (e) {
        console.error(e)
      }
    },
    open(row) {
      this.visible = true
      if (row) {
        this.isEdit = true
        this.editingId = row.id
        this.form = {
          name: row.name || '',
          categoryId: row.categoryId ? Number(row.categoryId) : null,
          description: row.description || '',
          brand: row.brand || '',
          fineness: row.fineness === 'secondHand' ? (row.finenessGrade || 'secondHand') : (row.fineness || ''),
          finenessGrade: row.finenessGrade || '',
          itemValue: row.itemValue || '',
          depositPrice: row.depositPrice || '',
          stock: row.stock != null ? row.stock : 1,
          status: row.status || 1,
          images: row.images || ''
        }
        this.buildImageList(row.images)
      } else {
        this.isEdit = false
        this.editingId = null
        this.imageList = []
      }
    },
    buildImageList(images) {
      this.imageList = []
      if (!images) return
      try {
        const arr = JSON.parse(images)
        arr.forEach((url, index) => {
          this.imageList.push({ url, uid: index, status: 'success' })
        })
      } catch {
        const arr = images.split(',')
        arr.forEach((url, index) => {
          this.imageList.push({ url, uid: index, status: 'success' })
        })
      }
    },
    handleClosed() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        name: '',
        categoryId: null,
        description: '',
        brand: '',
        fineness: '',
        finenessGrade: '',
        itemValue: '',
        depositPrice: '',
        stock: 1,
        status: 1,
        images: ''
      }
      this.imageList = []
    },
    handleFinenessChange(value) {
      if (value === 'wholeNew') {
        this.form.fineness = 'wholeNew'
        this.form.finenessGrade = ''
      } else {
        this.form.fineness = 'secondHand'
        this.form.finenessGrade = value
      }
    },
    handlePicturePreview(file) {
      this.previewUrl = file.url
      this.previewVisible = true
    },
    handlePictureRemove(file, fileList) {
      this.imageList = fileList
      this.form.images = JSON.stringify(fileList.map(f => f.response?.data || f.url))
    },
    handleUploadSuccess(response, file, fileList) {
      this.imageList = fileList
      this.form.images = JSON.stringify(fileList.map(f => f.response?.data || f.url))
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await updateGoods(this.editingId, this.form)
            this.$message.success('更新成功')
          } else {
            await createGoods(this.form)
            this.$message.success('创建成功')
          }
          this.visible = false
          this.$emit('saved')
        } catch (e) {
          console.error(e)
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
/* 弹窗整体优化 */
.el-dialog__wrapper >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.el-dialog__wrapper >>> .el-dialog__header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.el-dialog__wrapper >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.el-dialog__wrapper >>> .el-dialog__body {
  padding: 24px 24px 8px;
}

.el-dialog__wrapper >>> .el-dialog__footer {
  padding: 12px 24px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.el-dialog__wrapper >>> .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.el-dialog__wrapper >>> .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
  color: #999;
}

.el-dialog__wrapper >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #1677ff;
}
</style>
